module.exports = __webpack_public_path__ + "static/junior-8-b539beece96956bfca5319fb9c6248d1.jpg";